// extracted by mini-css-extract-plugin
export var intro = "SectionHeader-module--intro--XsXsP";
export var pageContent = "SectionHeader-module--page-content--vrySk";
export var sectionHeader = "SectionHeader-module--section-header--xsLxz";
export var sectionSpacingB = "SectionHeader-module--section-spacing-b--HWjqi";
export var sectionSpacingT = "SectionHeader-module--section-spacing-t--w2+z3";